import { React, useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import FetchModule from '../../Share/Network/FetchModule';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import NewTitleInput from '../../../Component/NoticeComponent/NewTitleInput';
import NewTextArea from '../../../Component/NoticeComponent/NewTextArea';
import NotRegistrationCardModal from '../../Share/Normal/NotRegistrationCardModal';
import NoticePictureInput from './NoticePictureInput';
import AiAssistant from '../../Share/Normal/AiAssistant';
import CustomScrollbar from '../../Share/Normal/CustomScrollbar';
import useTossCardRegister from '../../Share/Normal/useTossCardRegister';

import { ReactComponent as ExitButtonSvg } from '../../../image/ExitButton.svg';
import { ReactComponent as URLIconSvg } from '../../../image/Url.svg';
import KakaoTalkSpeechBubbleIcon from '../../../image/KakaoTalkSpeechBubbleIcon.png';
import { ReactComponent as PinIconSvg } from '../../../image/Pin2.svg';

const NewNoticeCreateBox = forwardRef((props, ref) => {
  const { maxNoticeTop = 0, onExceedFixedLimit } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const registerCard = useTossCardRegister();

  const [value, setValue] = useState('');
  const [countData, setCountData] = useState({ isRegistrationCard: false, validCount: 0, invalidCount: 0 });
  const [storeLogo, setStoreLogo] = useState('');

  const [isClickedKakaoBiz, setIsClickedKakaoBiz] = useState(false);
  const [isClickedValid, setIsClickedValid] = useState(false);
  const [isClickedInvalid, setIsClickedInvalid] = useState(false);

  const [isViewRegistrationCard, setIsViewRegistrationCard] = useState(false);

  const [urls, setUrls] = useState([]);

  const [isNeedCheckURL, setIsNeedCheckURL] = useState(false);
  const [isClickedFixed, setIsClickedFixed] = useState(false);
  const [alimtalkPrice, setAlimtalkPrice] = useState(10);

  const TitleRef = useRef();
  const PictureRef = useRef();
  const VideoScrollRef = useRef();

  useImperativeHandle(ref, () => ({
    getTitle: () => {
      return TitleRef.current.getValue();
    },
    getValue: () => {
      let fianlURL = '';

      for (let i = 0; i < urls.length; i++) {
        fianlURL += (urls[i] + ' ');
      }

      return value + '\n' + fianlURL;
    },
    getPicture: () => {
      return PictureRef.current.getPictures();
    },
    getIsClickedKakaoBiz: () => {
      return isClickedKakaoBiz;
    },
    getIsClickedValid: () => {
      return isClickedValid;
    },
    getIsClickedInvalid: () => {
      return isClickedInvalid;
    },
    getIsFixed: () => {
      return isClickedFixed;
    }
  }))

  // 입력값 변경 시 URL 자동 추출 //
  useEffect(() => {
    if (!isNeedCheckURL) return;

    let newContent = value;
    let newUrls = urls.slice();

    while (true) {
      let url = collectURL(newContent);

      if (url === '') break;
      else {
        newContent = newContent.replace(url, '');
        newUrls.push(url.replaceAll(',', ''));
      }
    }

    setUrls(newUrls);
    setValue(newContent);
    setIsNeedCheckURL(false);
  }, [value, urls, isNeedCheckURL])

  // 비디오 영역 휠 → 가로 스크롤 //
  useEffect(() => {
    const el = VideoScrollRef.current;
    if (!el) return;

    function onWheel(e) {
      if (el.scrollWidth <= el.clientWidth) return;
      const delta = e.deltaY !== 0 ? e.deltaY : e.deltaX;
      if (delta === 0) return;
      e.preventDefault();
      el.scrollLeft += delta;
    }

    el.addEventListener('wheel', onWheel, { passive: false });
    return () => el.removeEventListener('wheel', onWheel);
  }, [urls])

  // 회원수 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/count', 'GET');

        if (responseData.status === 200) {
          setStoreLogo(responseData.data.storeLogo);
          setCountData(responseData.data);
        }
      }
    )();
  }, [])

  // 메세지 단가 조회 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('message/pricing', 'GET');

        if (responseData.status === 200) {
          let alimtalk = responseData.data.find((item) => item.messageType === 'ALIMTALK');
          if (alimtalk) setAlimtalkPrice(alimtalk.unitPrice);
        }
      }
    )();
  }, [])

  // 붙여넣기나 스페이스바, 엔터키 감지시 URL 체크 //
  function onCheckURL() {
    setTimeout(() => {
      setIsNeedCheckURL(true);
    }, 100);
  }

  // 공지사항내에 링크 추출 //
  function collectURL(text) {
    let urlRegex = /(https?:\/\/[^ ]*)/;
    let url = text.match(urlRegex) === null ? '' : text.match(urlRegex)[1];

    return url;
  }

  // 링크 클릭시 //
  function onClickURL(url) {
    window.open(url, "_blank", "noreferrer");
  }

  // URL 삭제 클릭시 //
  function onClickDeleteURL(index) {
    let newURLs = urls.slice();

    newURLs.splice(index, 1);
    setUrls(newURLs);
  }

  // 유튜브링크인지 확인 //
  function decideYoutubeLink(url) {
    if (!url.includes('https://youtu.be/') && !url.includes('https://www.youtube.com/watch?v=')) {
      return false;
    }
    else if (url.includes('https://youtu.be/')
      && (url.split('https://youtu.be/')[0] !== '' || url.split('https://youtu.be/')[1] === '')) {
      return false;
    }
    else if (url.includes('https://www.youtube.com/watch?v=')
      && (url.split('https://www.youtube.com/watch?v=')[0] !== '' || url.split('https://www.youtube.com/watch?v=')[1] === '')) {
      return false;
    }
    else return true;
  }

  // 유튜브링크인지 확인후 Id 만 추출 //
  function decideYoutubeLinkVideoId(url) {
    if (url.includes('https://youtu.be/')) return url.replace('https://youtu.be/', '');
    else if (url.includes('https://www.youtube.com/watch?v=')) return url.replace('https://www.youtube.com/watch?v=', '')
  }

  // 카카오 알림톡 발송 회원수 결정 //
  function decideMemberCount() {
    if (isClickedValid && isClickedInvalid) return (countData.validCount + countData.invalidCount).toLocaleString('ko-KR');
    else if (isClickedValid) return countData.validCount.toLocaleString('ko-KR');
    else if (isClickedInvalid) return countData.invalidCount.toLocaleString('ko-KR');
    else return 0;
  }

  // 카카오 알림톡 발송 회원수에 따른 발송 금액 계산 //
  function decideCalcKakaoBizPrice() {
    if (isClickedValid && isClickedInvalid) return ((countData.validCount + countData.invalidCount) * alimtalkPrice).toLocaleString('ko-KR');
    else if (isClickedValid) return (countData.validCount * alimtalkPrice).toLocaleString('ko-KR');
    else if (isClickedInvalid) return (countData.invalidCount * alimtalkPrice).toLocaleString('ko-KR');
    else return 0;
  }

  // 카카오 알림톡 버튼 클릭시 //
  function onClickKakaoBiz() {
    // 카드번호 입력이 안되어있는 경우 //
    if (!countData.isRegistrationCard) {
      // 모달 표출 //
      setIsViewRegistrationCard(true);
    }
    else {
      setIsClickedKakaoBiz(!isClickedKakaoBiz);
    }
  }

  // 입력하기 버튼 클릭시 (Toss BrandPay v2 SDK) — useTossCardRegister 훅 위임 //
  function onClickRegistrationCard() {
    registerCard({
      onSuccess: () => {
        setCountData({ isRegistrationCard: true, validCount: countData.validCount, invalidCount: countData.invalidCount });
        setIsViewRegistrationCard(false);
      }
    });
  }

  // ============================================================================
  // ⚠️ DO NOT DELETE - Payple 레거시 코드 (Toss 이관 후 사용자가 직접 정리 예정)
  // Claude는 이 주석 블록을 절대 삭제/수정하지 말 것
  // 이관 일자: 2026-08-10
  // 사유: 공지 발송 카드 등록(NewNoticeCreateBox "입력하기")을 Toss BrandPay 로 이관. 듀얼 PG 운영 중 기존 페이플 가입자 대응 참조용
  // ----------------------------------------------------------------------------
  // // 입력하기 버튼 클릭시 //
  // function onClickRegistrationCard() {
  //   const obj = {};
  //
  //   obj.PCD_PAY_TYPE = 'card'
  //   obj.PCD_PAY_WORK = 'AUTH'
  //   obj.PCD_CARD_VER = '01';
  //   obj.PCD_PAYER_AUTHTYPE = 'sms';
  //
  //   obj.callbackFunction = getResult;
  //   obj.clientKey = '0F44C92BFB07F1BE60C5235A7254316D';
  //
  //   window.PaypleCpayAuthCheck(obj);
  // }
  //
  // // 결제 이후 콜백 //
  // function getResult(res) {
  //   if (res.PCD_PAY_RST === 'success' && (res.PCD_PAY_CODE === '0000' || res.PCD_PAY_CODE === 'CDAU1000')) {
  //     let requestData = {
  //       billingKey: res.PCD_PAYER_ID,
  //       cardName: res.PCD_PAY_CARDNAME,
  //       cardNum: res.PCD_PAY_CARDNUM
  //     }
  //     const fetchModule = new FetchModule();
  //     (
  //       async () => {
  //         const responseData = await fetchModule.postDataVersion2('billing/registry', 'POST', requestData);
  //
  //         if (responseData.status === 200) {
  //           alert(t('noticePage.alertCardRegistered'));
  //           setCountData({ isRegistrationCard: true, validCount: countData.validCount, invalidCount: countData.invalidCount });
  //           setIsViewRegistrationCard(false);
  //         }
  //         else if (responseData.status === 201) {
  //           alert(t('noticePage.alertAlreadyRegistered'));
  //           setIsViewRegistrationCard(false);
  //         }
  //       }
  //     )();
  //   }
  //   else {
  //     if (res.PCD_PAY_CODE === undefined) {
  //       alert(res.PCD_PAY_MSG);
  //     }
  //     else {
  //       alert('[' + res.PCD_PAY_CODE + ']' + ' ' + res.PCD_PAY_MSG);
  //     }
  //   }
  // }
  // ============================================================================

  // AI 어시스턴트 생성 컨텍스트 //
  function decideAiContext() {
    return { currentTitle: TitleRef.current?.getValue?.() ?? '', currentContent: value };
  }

  // AI 어시스턴트 결과 적용 //
  function onApplyAiResult(title, content) {
    TitleRef.current?.setValue(title);
    setValue(content);
  }

  // 상단고정 토글 클릭시 — 고정 공지가 이미 5개면 모달 표출, 아니면 토글 //
  function onClickFixedToggle() {
    if (isClickedFixed) {
      setIsClickedFixed(false);
      return;
    }

    if (maxNoticeTop >= 5) {
      onExceedFixedLimit?.();
      return;
    }

    setIsClickedFixed(true);
  }

  return (
    <TopLevelWrapper>
      {
        isViewRegistrationCard &&
        <NotRegistrationCardModal division='Notice' setIsViewModal={setIsViewRegistrationCard} onClickRegistCard={onClickRegistrationCard} />
      }
      <ViewWrapper isDark={isDark}>
        <ComponentWrapper>
          <TitleWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('noticePage.titleLabel')}</Text>
            <FixingWrapper>
              <PinIcon />
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>{t('noticePage.pinToTop')}</Text>
            </FixingWrapper>
          </TitleWrapper>
          <TitleInputWrapper>
            <NewTitleInput ref={TitleRef} storeLogo={storeLogo} placeholder={t('noticePage.titlePlaceholder')} />
            <SlideComponentWrappper onClick={onClickFixedToggle}>
              <SlideOutBox isClicked={isClickedFixed}>
                <SlideInBox isClicked={isClickedFixed} />
              </SlideOutBox>
            </SlideComponentWrappper>
          </TitleInputWrapper>
        </ComponentWrapper>
        <ContentWrapper>
          <ComponentWrapper>
            <Title>{t('noticePage.contentLabel')}</Title>
            <NewTextArea value={value} setValue={setValue} checkURL={onCheckURL} />
          </ComponentWrapper>
          {
            urls.some(url => !decideYoutubeLink(url)) &&
            <URLWrapper>
              {
                urls.map((data, index) => (
                  !decideYoutubeLink(data) &&
                  <URLTextBox key={'URLTextBox-' + index}>
                    <InnerURLTextBox onClick={() => onClickURL(data)}>
                      <URLIcon />
                      <TextWrapper>
                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{data}</Text>
                      </TextWrapper>
                    </InnerURLTextBox>
                    <DeleteButton onClick={() => onClickDeleteURL(index)} margin='0px 0px 0px 0px' width={20} height={20} radius={20}>
                      <ExitIcon width={9} height={9} />
                    </DeleteButton>
                  </URLTextBox>
                ))
              }
            </URLWrapper>
          }
          {
            urls.some(url => decideYoutubeLink(url)) &&
            <VideoOuterWrapper $hasScrollbar={urls.filter(url => decideYoutubeLink(url)).length >= 2}>
              <VideoWrapper ref={VideoScrollRef}>
                {
                  urls.map((data, index) => (
                    decideYoutubeLink(data) &&
                    <VideoViewWrapper key={'VideoViewWrapper-' + index}>
                      <iframe
                        width="100%"
                        height="100%"
                        src={`https://www.youtube.com/embed/` + decideYoutubeLinkVideoId(data)}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Embedded youtube" />
                      <VideoDeleteButtonWrapper onClick={() => onClickDeleteURL(index)} >
                        <DeleteButton margin='10px 10px 0px 0px' width={20} height={20} radius={20}>
                          <ExitIcon width={9} height={9} />
                        </DeleteButton>
                      </VideoDeleteButtonWrapper>
                    </VideoViewWrapper>
                  ))
                }
              </VideoWrapper>
              {
                urls.filter(url => decideYoutubeLink(url)).length >= 2 &&
                <ScrollbarWrapper>
                  <CustomScrollbar
                    direction='horizontal'
                    scrollRef={VideoScrollRef}
                    IsColorScrollBar={true}
                    isTrackThin={true}
                    showTrackAlways={false} />
                </ScrollbarWrapper>
              }
            </VideoOuterWrapper>
          }
          {/* <TotalKakaoSendWrapper>
          <KakaoSendWrapper isClicked={isClickedKakaoBiz}>
            <TotalSendInfoWrapper>
              <SendInfoWrapper gap={16}>
                <CheckBoxWrapper onClick={() => setIsClickedValid(!isClickedValid)}>
                  <SendCheckBox isClicked={isClickedValid} />
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#666666' cursor='pointer'>{t('noticePage.validMember')}</Text>
                </CheckBoxWrapper>
              </SendInfoWrapper>
              <SendInfoWrapper gap={16}>
                <TotalTextWrapper>
                  <SendTextWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#666666' cursor='default'>{t('noticePage.kakaoSendInfo', { count: decideMemberCount() })}</Text>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{t('noticePage.kakaoSendPrice', { price: decideCalcKakaoBizPrice() })}</Text>
                  </SendTextWrapper>
                </TotalTextWrapper>
              </SendInfoWrapper>
            </TotalSendInfoWrapper>
            <KakaoSendButton isClicked={isClickedKakaoBiz} onClick={onClickKakaoBiz}>
              <Icon src={KakaoTalkSpeechBubbleIcon} width={26} height={24} style={{ margin: `-1px 0px 0px -3px` }} />
            </KakaoSendButton>
          </KakaoSendWrapper>
        </TotalKakaoSendWrapper> */}
        </ContentWrapper>
        <DivisionLine />
        <AiAssistantWrapper>
          <AiAssistant
            type='notice'
            context={decideAiContext}
            onApply={onApplyAiResult} />
        </AiAssistantWrapper>
      </ViewWrapper>
      <NoticePictureInput ref={PictureRef} />
    </TopLevelWrapper>
  )
})

export default NewNoticeCreateBox;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 1035px;

  gap: 20px;

  margin-top: 30px;
  margin-bottom: 96px;
  padding-bottom: 68px;
`;

const ViewWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px 0;

  box-sizing: border-box;
  width: 590px;

  gap: 20px;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 0px 20px;

  box-sizing: border-box;
  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
  height: 26px;
`;

const FixingButton = styled.div`
  display: grid;

  justify-items: center;
  align-items: center;

  padding: 0px 10px;

  height: 28px;

  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.pointRed : props.theme.background};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const FixingWrapper = styled.div`
  grid-area: 1 / 1;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 3px;

  white-space: nowrap;

  opacity: ${props => props.opacity};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PinIcon = styled(PinIconSvg)`
  width: 16px;
  height: 16px;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.text};
    transition: fill 0.3s ease-in-out;
  }
`;


const TitleInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const SlideComponentWrappper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 8px;

  transition: all 0.3s ease-in-out;
`;

const SlideOutBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  box-sizing: border-box;
  width: 70px;
  height: 32px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 9px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const SlideInBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-left: ${props => props.isClicked ? '43px' : '4px'};

  width: 22px;
  height: 22px;

  border-radius: 7px;
  background-color: ${props => props.isClicked ? props.theme.white : props.theme.line};

  transition: all 0.3s ease-in-out;
`;

const Title = styled.p`
  display: flex;
  flex-direction: row;

  height: 26px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  color: ${props => props.theme.text};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 550px;

  gap: 20px;
`;

const DivisionLine = styled.div`
  margin: 10px 30px;

  width: 530px;
  height: 1px;

  background-color: ${props => props.theme.line};
`;

const AiAssistantWrapper = styled.div`
  width: 550px;

  padding: 0 20px;
`

const URLWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 0 20px;

  width: 550px;

  gap: 4px;
`;

const URLTextBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 15px;

  box-sizing: border-box;
  width: 100%;
  height: 52px;

  gap: 10px;

  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const InnerURLTextBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  flex: 1;
  min-width: 0;
  height: 22px;

  gap: 10px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 22px;

  overflow: hidden;
`;

const VideoOuterWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin: 0 20px;
  margin-bottom: ${props => props.$hasScrollbar ? '0' : '25px'};

  width: 550px;
`;

const VideoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;

  overflow-x: auto;
  overflow-y: hidden;

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ScrollbarWrapper = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const VideoViewWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  width: 300px;
  height: 169px;

  flex-shrink: 0;

  overflow: hidden;

  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  & iframe {
    display: block;
    border: none;
    background-color: ${props => props.theme.subBackground};
    pointer-events: none;
  }
`;

const VideoDeleteButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  width: 100%;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  flex-shrink: 0;

  margin: ${props => props.margin};

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: ${props => props.radius}px;
  background-color: ${props => props.theme.buttonFill3};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Icon = styled.img`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;

const ExitIcon = styled(ExitButtonSvg)`
  width: ${props => props.width}px;
  height: ${props => props.height}px;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.text};
  }

  & rect {
    fill: ${props => props.theme.text};
  }
`;

const URLIcon = styled(URLIconSvg)`
  width: 20px;
  height: 20px;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.text};
    transition: fill 0.3s ease-in-out;
  }
`;


const TotalKakaoSendWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-end;

  margin-top: 16px;

  width: 100%;
  height: 41px;

  overflow: hidden;
`;

const KakaoSendWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: ${props => props.isClicked ? `100%` : `51px`};
  height: 100%;

  overflow: hidden;

  border-radius: ${props => props.isClicked ? `0px 0px 30px 30px` : `8px 0px 30px 0px`};
  background-color: #FFF9C3;

  transition: all 0.3s ease-in-out;
`;

const TotalSendInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin: 0px 16px 0px 28px;

  width: 92.85%;
`;

const SendInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: ${props => props.gap}px;
`;

const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  white-space: nowrap;

  gap: 8px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TotalTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 16px;
`;

const SendTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  white-space: nowrap;

  gap: 4px;
`;

const SendCheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 14px;
  height: 14px;

  border-radius: 16px;
  border: 1px solid ${props => props.theme.line};
  background-color: ${props => props.isClicked ? `#F9E000` : props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const KakaoSendButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 51px;
  height: 41px;
  min-width: 51px;
  min-height: 41px;
  max-width: 51px;
  max-height: 51px;

  border-radius: 8px 0px 30px 0px;
  background-color: ${props => props.isClicked ? `#F9E000` : `#FFF48D`};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
